
// import React, { useState } from 'react';
// import { useNavigate, useLocation } from 'react-router-dom';
// import { authAPI } from '../../api/auth.api';
// import Input from '../../components/common/Input';
// import Button from '../../components/common/Button';
// import styles from './ForgotPassword.module.css';

// const ForgotPassword = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const emailFromState = location.state?.email || '';

//   const [email, setEmail] = useState(emailFromState);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState('');
//   const [emailError, setEmailError] = useState('');

//   const validateEmail = (email) => {
//     const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     return re.test(email);
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError('');
//     setEmailError('');

//     if (!email.trim()) {
//       setEmailError('Email is required');
//       return;
//     }

//     if (!validateEmail(email)) {
//       setEmailError('Please enter a valid email');
//       return;
//     }

//     setLoading(true);

//     try {
//       const response = await authAPI.forgotPassword(email);
      
//       // Redirect to reset password page
//       navigate('/reset-password', { 
//         state: { 
//           email,
//           message: response.message 
//         } 
//       });
//     } catch (err) {
//       setError(err.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className={styles.container}>
//       <div className={styles.card}>
//         <h1 className={styles.title}>Forgot Password?</h1>
//         <p className={styles.subtitle}>
//           Enter your email address and we'll send you an OTP to reset your password
//         </p>

//         {error && (
//           <div className={`${styles.alert} ${styles.alertError}`}>
//             {error}
//           </div>
//         )}

//         <form className={styles.form} onSubmit={handleSubmit}>
//           <Input
//             type="email"
//             label="Email Address"
//             placeholder="Enter your email"
//             value={email}
//             onChange={(e) => setEmail(e.target.value)}
//             error={emailError}
//             disabled={loading}
//             autoFocus
//           />

//           <Button type="submit" fullWidth loading={loading}>
//             Send OTP
//           </Button>

//           <button 
//             type="button" 
//             className={styles.link}
//             onClick={() => navigate('/login')}
//           >
//             Back to Login
//           </button>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default ForgotPassword;

import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { authAPI } from '../../api/auth.api';
import logo from '../../assets/images/density_logo_new_trans.png';
import styles from './ForgotPassword.module.css';

const ForgotPassword = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const emailFromState = location.state?.email || '';

  const [email, setEmail] = useState(emailFromState);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [emailError, setEmailError] = useState('');
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setEmailError('');

    if (!email.trim()) {
      setEmailError('Email is required');
      return;
    }

    if (!validateEmail(email)) {
      setEmailError('Please enter a valid email');
      return;
    }

    setLoading(true);

    try {
      await authAPI.forgotPassword(email);
      navigate('/reset-password', {
        state: { email },
      });
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.root}>
      {/* LEFT PANEL */}
      <div className={styles.left}>
        <div className={styles.leftBg} />
        <div className={styles.gridOverlay} />
        <div className={`${styles.orb} ${styles.orb1}`} />
        <div className={`${styles.orb} ${styles.orb2}`} />
        <div className={`${styles.orb} ${styles.orb3}`} />
        <div className={styles.leftContent}>
          <div className={styles.divider} />
          <div className={styles.tagline}>
            Density —<br />
            <span>Happy to be</span><br />
            <em>bothered.</em>
          </div>
          <p className={styles.leftSub}>
            Your workspace for data-driven decisions — precise, fast, and beautifully simple.
          </p>
          <div className={styles.badgeRow}>
            <span className={styles.badge}>Analytics</span>
            <span className={styles.badge}>Real-time</span>
            <span className={styles.badge}>Insights</span>
          </div>
        </div>
      </div>

      {/* RIGHT PANEL */}
      <div className={styles.right}>
        <div className={`${styles.rightInner} ${mounted ? styles.mounted : ''}`}>

          <div className={styles.logoWrap}>
            <img src={logo} alt="Density" className={styles.logoImg} />
          </div>

          <h1 className={styles.heading}>
            Forgot your <em>password?</em>
          </h1>
          <p className={styles.subtitle}>
            Enter your email and we'll send you an OTP to reset it.
          </p>

          {error && (
            <div className={styles.errorBox}>
              <svg className={styles.errorIcon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="10" />
                <line x1="12" y1="8" x2="12" y2="12" />
                <line x1="12" y1="16" x2="12.01" y2="16" />
              </svg>
              {error}
            </div>
          )}

          <form className={styles.form} onSubmit={handleSubmit} autoComplete="off">
            <div className={styles.field}>
              <label className={styles.label}>Email address</label>
              <input
                className={`${styles.input} ${emailError ? styles.inputError : ''}`}
                type="email"
                placeholder="you@company.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={loading}
                autoFocus
              />
              {emailError && <div className={styles.fieldError}>{emailError}</div>}
            </div>

            <button className={styles.btnPrimary} type="submit" disabled={loading}>
              <span className={styles.btnInner}>
                {loading && <span className={styles.spinner} />}
                {loading ? 'Sending…' : 'Send OTP →'}
              </span>
            </button>

            <div className={styles.linksRow}>
              <button
                type="button"
                className={styles.linkBtn}
                onClick={() => navigate('/login')}
              >
                ← Back to Login
              </button>
            </div>
          </form>

          <div className={styles.footer}>© {new Date().getFullYear()} Density Pharmachem. All rights reserved.</div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;